import { MultiSelect as React_MultiSelect } from 'react-multi-select-component';
import { languageElements as MultiSelect_LanguageElements } from './MultiSelect-languageElements';
import LanguageElementsHandler from '../../languageElementsHandler/LanguageElementsHandler';
import useMain from '../../../common/MainContext';

export default function MultiSelect(props) {
    const { language } = useMain();

    const languageElementsHandler = new LanguageElementsHandler(
        MultiSelect_LanguageElements,
        language
    );

    function handleInputChange(multiSelectFormattedValue) {
        props.onChange({
            target: {
                name: props.name,
                value: JSON.stringify(getDBFormattedValue(multiSelectFormattedValue)),
            }
        })
    }

    function getMultiSelectFormattedValue(DBValue) {
        //DBValue: [nameOfSelectedOptions] (stringified!!!)
        if (!DBValue) {
            return [];
        }

        const jsonDBValue = (typeof DBValue === 'string') ? JSON.parse(DBValue) : DBValue;

        return (
            props.optionList.options
                .filter(option => jsonDBValue[option.value]))
            .map(option => ({
                label: option.label,
                value: option.value,
            }))
    }

    function getDBFormattedValue(multiSelectFormattedValue) {
        //multiSelectFormattedValue: [{label, value}]
        const dbFormatted = {};

        multiSelectFormattedValue.forEach(option => {
            dbFormatted[option.value] = true
        });

        return dbFormatted
    }

    return (
        <div className={props.divErrorClass}>
            {props.labelArea}

            <React_MultiSelect
                options={props.optionList.options}
                className='sel-multiselect'
                value={getMultiSelectFormattedValue(props.value)}
                onChange={handleInputChange}
                overrideStrings={{
                    allItemsAreSelected: languageElementsHandler.get('multiSelect-allItemsAreSelected'),
                    clearSearch: languageElementsHandler.get('multiSelect-ClearSearch'),
                    clearSelected: languageElementsHandler.get('multiSelect-clearSelected'),
                    noOptions: languageElementsHandler.get('multiSelect-noOptions'),
                    search: languageElementsHandler.get('multiSelect-search'),
                    selectAll: languageElementsHandler.get('multiSelect-selectAll'),
                    selectAllFiltered: languageElementsHandler.get('multiSelect-selectAllFiltered'),
                    selectSomeItems: languageElementsHandler.get('multiSelect-selectSomeItems'),
                    create: languageElementsHandler.get('multiSelect-create'),
                }}
                hasSelectAll={props.optionList.hasSelectAll}
            />
        </div>
    )
}
